import React from 'react';
import { resolveThemeAssetUrl } from '../data/siteTheme';

// The extra stylised art a theme hangs on the banner. Every piece is placed
// from the logo's top-left corner, so the layer is positioned there and each
// asset just reads its own offsets. Nothing clips: a large enough Y drops a
// piece over the navigation bar.
//
// maxWidth/maxHeight none is load-bearing, not tidying. The origin div is 0x0,
// and Tailwind's preflight puts max-width:100% on every img, which for an
// absolutely positioned child resolves against that 0-wide containing block and
// collapses the art to nothing. It also keeps the pixel art at intrinsic size.
function ThemeDecorations({ decorations = [], origin, rightDrift = 0, interactive = false, selectedId = null, onGrab, forceVisible = false }) {
    if (decorations.length === 0) return null;

    return (
        <div className="absolute" style={{ left: origin.x, top: origin.y, width: 0, height: 0 }}>
            {decorations.map(decoration => (
                <img
                    key={decoration.id}
                    src={resolveThemeAssetUrl(decoration.url)}
                    alt=""
                    aria-hidden="true"
                    draggable={false}
                    onMouseDown={interactive ? (e) => onGrab(e, decoration) : undefined}
                    className={`absolute ${forceVisible || decoration.desktopOnly === false ? 'block' : 'hidden lg:block'}`}
                    style={{
                        left: decoration.offsetX,
                        top: decoration.offsetY,
                        width: decoration.width || 'auto',
                        height: 'auto',
                        maxWidth: 'none',
                        maxHeight: 'none',
                        zIndex: decoration.zIndex,
                        transform: decoration.anchorRight ? `translateX(${rightDrift}px)` : undefined,
                        imageRendering: 'pixelated',
                        pointerEvents: interactive ? 'auto' : 'none',
                        cursor: interactive ? 'grab' : undefined,
                        outline: selectedId === decoration.id ? '2px dashed #ffcc66' : undefined,
                        outlineOffset: 2
                    }}
                />
            ))}
        </div>
    );
}

export default ThemeDecorations;
